import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaHeader"*/ './lazyIndex'),
    {
        name: 'OwaHeader',
    }
);

export const lazySignout: LazyAction<typeof lazyIndex.signout, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.signout
);

export { addSignoutPromise } from './signoutPromises';
export type { SignoutPromiseCallback } from './signoutPromises';
